module.exports = __webpack_public_path__ + "static/media/animal-pig1.f3afc07e.aac";